<template>
	<div class="home_package_item" :class="[`home_package_item__${type}`]" @click="$emit('click')">
		<div class="icon">
			<img v-if="type === 'blue'" src="@/assets/icon/icon_package_blue.png" alt="" />
			<img v-else-if="type === 'pink'" src="@/assets/icon/icon_package_pink.png" alt="" />
			<img v-else src="@/assets/icon/icon_package_primary.png" alt="" />
		</div>
		<div class="content van-ellipsis">
			<span>{{ label }}</span>
		</div>
		<div class="arrow">
			<img v-if="type === 'blue'" src="@/assets/icon/icon_arrow_blue.png" alt="" />
			<img v-else-if="type === 'pink'" src="@/assets/icon/icon_arrow_pink.png" alt="" />
			<img v-else src="@/assets/icon/icon_arrow_primary.png" alt="" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'homePackageItem',
		props: {
			type: {
				type: String,
				default: 'primary'
			},
			label: {
				type: String,
				default: ''
			}
		}
	};
</script>

<style scoped lang="less">
	.home_package_item {
		height: 100px;
		border-radius: 16px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-right: 28px;
		overflow: hidden;
		.icon {
			margin-top: 45px;
			margin-left: -10px;
			opacity: 0.5;
			>img {
				width: 110px;
				height: 110px;
				vertical-align: middle;
			}
		}
		.content {
			font-family: PingFangSC-Semibold;
			font-size: 30px;
			font-weight: normal;
			word-break: break-all;
		}
		.arrow>img {
			width: 28px;
			height: 28px;
			vertical-align: middle;
		}
		&.home_package_item__primary {
			background-color: mix(#fff, @primary, 90%);
			.content {
				color: @primary;
			}
		}
		&.home_package_item__blue {
			background-color: mix(#fff, @info, 90%);
			.content {
				color: @info;
			}
		}
		&.home_package_item__pink {
			background-color: mix(#fff, #9676ED, 90%);
			.content {
				color: #9676ED;
			}
		}
	}
</style>
